export default __webpack_public_path__ + "static/media/Alimentação.ff968951.svg";